/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { createFileRoute } from '@tanstack/react-router'

import { Route as rootRouteImport } from './routes/__root'
import { Route as ClearCutsRouteImport } from './routes/_clear-cuts'
import { Route as AboutRouteImport } from './routes/about'
import { Route as AdministrationRouteImport } from './routes/administration'
import { Route as ForgotPasswordRouteImport } from './routes/forgot-password'
import { Route as LoginRouteImport } from './routes/login'
import { Route as MyCutsRouteImport } from './routes/my-cuts'
import { Route as RegisterRouteImport } from './routes/register'
import { Route as ResetPasswordRouteImport } from './routes/reset-password'

const IndexLazyRouteImport = createFileRoute('/')()
const ClearCutsClearCutsIndexLazyRouteImport = createFileRoute(
  '/_clear-cuts/clear-cuts/',
)()
const ClearCutsClearCutsClearCutIdLazyRouteImport = createFileRoute(
  '/_clear-cuts/clear-cuts/$clearCutId',
)()

const IndexLazyRoute = IndexLazyRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRouteImport,
} as any).lazy(() => import('./routes/index.lazy').then((d) => d.Route))
const ClearCutsRoute = ClearCutsRouteImport.update({
  id: '/_clear-cuts',
  getParentRoute: () => rootRouteImport,
} as any)
const AboutRoute = AboutRouteImport.update({
  id: '/about',
  path: '/about',
  getParentRoute: () => rootRouteImport,
} as any)
const AdministrationRoute = AdministrationRouteImport.update({
  id: '/administration',
  path: '/administration',
  getParentRoute: () => rootRouteImport,
} as any)
const ForgotPasswordRoute = ForgotPasswordRouteImport.update({
  id: '/forgot-password',
  path: '/forgot-password',
  getParentRoute: () => rootRouteImport,
} as any)
const LoginRoute = LoginRouteImport.update({
  id: '/login',
  path: '/login',
  getParentRoute: () => rootRouteImport,
} as any)
const MyCutsRoute = MyCutsRouteImport.update({
  id: '/my-cuts',
  path: '/my-cuts',
  getParentRoute: () => rootRouteImport,
} as any)
const RegisterRoute = RegisterRouteImport.update({
  id: '/register',
  path: '/register',
  getParentRoute: () => rootRouteImport,
} as any)
const ResetPasswordRoute = ResetPasswordRouteImport.update({
  id: '/reset-password',
  path: '/reset-password',
  getParentRoute: () => rootRouteImport,
} as any)
const ClearCutsClearCutsIndexLazyRoute =
  ClearCutsClearCutsIndexLazyRouteImport.update({
    id: '/clear-cuts/',
    path: '/clear-cuts/',
    getParentRoute: () => ClearCutsRoute,
  } as any).lazy(() =>
    import('./routes/_clear-cuts.clear-cuts.index.lazy').then((d) => d.Route),
  )
const ClearCutsClearCutsClearCutIdLazyRoute =
  ClearCutsClearCutsClearCutIdLazyRouteImport.update({
    id: '/clear-cuts/$clearCutId',
    path: '/clear-cuts/$clearCutId',
    getParentRoute: () => ClearCutsRoute,
  } as any).lazy(() =>
    import('./routes/_clear-cuts.clear-cuts.$clearCutId.lazy').then(
      (d) => d.Route,
    ),
  )

export interface FileRoutesByFullPath {
  '/': typeof IndexLazyRoute
  '/about': typeof AboutRoute
  '/administration': typeof AdministrationRoute
  '/forgot-password': typeof ForgotPasswordRoute
  '/login': typeof LoginRoute
  '/my-cuts': typeof MyCutsRoute
  '/register': typeof RegisterRoute
  '/reset-password': typeof ResetPasswordRoute
  '/clear-cuts/$clearCutId': typeof ClearCutsClearCutsClearCutIdLazyRoute
  '/clear-cuts/': typeof ClearCutsClearCutsIndexLazyRoute
}
export interface FileRoutesByTo {
  '/': typeof IndexLazyRoute
  '/about': typeof AboutRoute
  '/administration': typeof AdministrationRoute
  '/forgot-password': typeof ForgotPasswordRoute
  '/login': typeof LoginRoute
  '/my-cuts': typeof MyCutsRoute
  '/register': typeof RegisterRoute
  '/reset-password': typeof ResetPasswordRoute
  '/clear-cuts/$clearCutId': typeof ClearCutsClearCutsClearCutIdLazyRoute
  '/clear-cuts': typeof ClearCutsClearCutsIndexLazyRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/': typeof IndexLazyRoute
  '/_clear-cuts': typeof ClearCutsRouteWithChildren
  '/about': typeof AboutRoute
  '/administration': typeof AdministrationRoute
  '/forgot-password': typeof ForgotPasswordRoute
  '/login': typeof LoginRoute
  '/my-cuts': typeof MyCutsRoute
  '/register': typeof RegisterRoute
  '/reset-password': typeof ResetPasswordRoute
  '/_clear-cuts/clear-cuts/$clearCutId': typeof ClearCutsClearCutsClearCutIdLazyRoute
  '/_clear-cuts/clear-cuts/': typeof ClearCutsClearCutsIndexLazyRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/about'
    | '/administration'
    | '/forgot-password'
    | '/login'
    | '/my-cuts'
    | '/register'
    | '/reset-password'
    | '/clear-cuts/$clearCutId'
    | '/clear-cuts/'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/about'
    | '/administration'
    | '/forgot-password'
    | '/login'
    | '/my-cuts'
    | '/register'
    | '/reset-password'
    | '/clear-cuts/$clearCutId'
    | '/clear-cuts'
  id:
    | '__root__'
    | '/'
    | '/_clear-cuts'
    | '/about'
    | '/administration'
    | '/forgot-password'
    | '/login'
    | '/my-cuts'
    | '/register'
    | '/reset-password'
    | '/_clear-cuts/clear-cuts/$clearCutId'
    | '/_clear-cuts/clear-cuts/'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  IndexLazyRoute: typeof IndexLazyRoute
  ClearCutsRoute: typeof ClearCutsRouteWithChildren
  AboutRoute: typeof AboutRoute
  AdministrationRoute: typeof AdministrationRoute
  ForgotPasswordRoute: typeof ForgotPasswordRoute
  LoginRoute: typeof LoginRoute
  MyCutsRoute: typeof MyCutsRoute
  RegisterRoute: typeof RegisterRoute
  ResetPasswordRoute: typeof ResetPasswordRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexLazyRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_clear-cuts': {
      id: '/_clear-cuts'
      path: ''
      fullPath: '/'
      preLoaderRoute: typeof ClearCutsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/about': {
      id: '/about'
      path: '/about'
      fullPath: '/about'
      preLoaderRoute: typeof AboutRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/administration': {
      id: '/administration'
      path: '/administration'
      fullPath: '/administration'
      preLoaderRoute: typeof AdministrationRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/forgot-password': {
      id: '/forgot-password'
      path: '/forgot-password'
      fullPath: '/forgot-password'
      preLoaderRoute: typeof ForgotPasswordRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/login': {
      id: '/login'
      path: '/login'
      fullPath: '/login'
      preLoaderRoute: typeof LoginRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/my-cuts': {
      id: '/my-cuts'
      path: '/my-cuts'
      fullPath: '/my-cuts'
      preLoaderRoute: typeof MyCutsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/register': {
      id: '/register'
      path: '/register'
      fullPath: '/register'
      preLoaderRoute: typeof RegisterRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/reset-password': {
      id: '/reset-password'
      path: '/reset-password'
      fullPath: '/reset-password'
      preLoaderRoute: typeof ResetPasswordRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_clear-cuts/clear-cuts/': {
      id: '/_clear-cuts/clear-cuts/'
      path: '/clear-cuts'
      fullPath: '/clear-cuts/'
      preLoaderRoute: typeof ClearCutsClearCutsIndexLazyRouteImport
      parentRoute: typeof ClearCutsRoute
    }
    '/_clear-cuts/clear-cuts/$clearCutId': {
      id: '/_clear-cuts/clear-cuts/$clearCutId'
      path: '/clear-cuts/$clearCutId'
      fullPath: '/clear-cuts/$clearCutId'
      preLoaderRoute: typeof ClearCutsClearCutsClearCutIdLazyRouteImport
      parentRoute: typeof ClearCutsRoute
    }
  }
}

interface ClearCutsRouteChildren {
  ClearCutsClearCutsClearCutIdLazyRoute: typeof ClearCutsClearCutsClearCutIdLazyRoute
  ClearCutsClearCutsIndexLazyRoute: typeof ClearCutsClearCutsIndexLazyRoute
}

const ClearCutsRouteChildren: ClearCutsRouteChildren = {
  ClearCutsClearCutsClearCutIdLazyRoute: ClearCutsClearCutsClearCutIdLazyRoute,
  ClearCutsClearCutsIndexLazyRoute: ClearCutsClearCutsIndexLazyRoute,
}

const ClearCutsRouteWithChildren = ClearCutsRoute._addFileChildren(
  ClearCutsRouteChildren,
)

const rootRouteChildren: RootRouteChildren = {
  IndexLazyRoute: IndexLazyRoute,
  ClearCutsRoute: ClearCutsRouteWithChildren,
  AboutRoute: AboutRoute,
  AdministrationRoute: AdministrationRoute,
  ForgotPasswordRoute: ForgotPasswordRoute,
  LoginRoute: LoginRoute,
  MyCutsRoute: MyCutsRoute,
  RegisterRoute: RegisterRoute,
  ResetPasswordRoute: ResetPasswordRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
